// 初始化数据
const modals = {
  submitData: {}, //基本信息数据
  uploadData: {},
  // uploadData_1: {}, //图片上传-身份证
  // uploadData_2: [], //图片上传约定书list
  showTab: '1', //标识的tab（基本信息，补充协议）
  verificationCodeFlag: 1, //是否可以获取原手机号验证码
  TaxCodeOrgName: {}, //获取供应商税号、机构名称
  supplierData: null,
  orginaMobile: null, //原手机号码
};
export default modals;
